/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateStoreAmenitiesRequest } from '../../models/update-store-amenities-request';
import { UpdateStoreAmenitiesResponse } from '../../models/update-store-amenities-response';

export interface PutStoreAmenities$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: UpdateStoreAmenitiesRequest
}

export function putStoreAmenities(http: HttpClient, rootUrl: string, params: PutStoreAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateStoreAmenitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, putStoreAmenities.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateStoreAmenitiesResponse>;
    })
  );
}

putStoreAmenities.PATH = '/stores/{storeId}/amenities';
